import {useMutation} from '@tanstack/react-query';
import {useChekinSDK} from '../context/ChekinSDK';
import {type CreateFeedbackPayload} from '@guestapp/sdk';
import {useIsMounted} from './common';

type Props = {
  onError?: (error: Error) => void;
};
function useMutateFeedback({onError}: Props = {}) {
  const {createFeedback} = useChekinSDK();
  const isMounted = useIsMounted();

  const {mutate: createFeedbackMutation, mutateAsync: createFeedbackAsyncMutation} =
    useMutation<unknown, Error, CreateFeedbackPayload>(createFeedback, {
      onError: error => {
        if (!isMounted.current) {
          return;
        }
        onError?.(error);
      },
    });

  return {createFeedbackMutation, createFeedbackAsyncMutation};
}

export {useMutateFeedback};
